import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryInvoiceGoodsName(requestBody) {
  return request({
    url: URL.act.invoiceGoodsName.queryUrl,
    method: 'post',
    data: requestBody
  })
}

export function saveInvoiceGoodsName(requestBody) {
  return request({
    url: URL.act.invoiceGoodsName.saveUrl,
    method: 'post',
    data: requestBody
  })
}

export function deleteInvoiceGoodsName(requestBody) {
  return request({
    url: URL.act.invoiceGoodsName.deleteUrl,
    method: 'post',
    data: requestBody
  })
}
